
import React from "react";
import { Menu, X } from "lucide-react";

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-primary/10 text-primary"
      aria-label="Toggle menu"
    >
      {isOpen ? <X size={20} /> : <Menu size={20} />}
    </button>
  );
};

export default MobileMenuButton;
